export const content = [
    {
      heading: 'Create account and complete KYC',
      description: ['Sign up with username and password. Verify your KYC which includes Pan Card, Adhaar card & Bank account details.']
    },
    {
      heading: 'Choose investment option',
      description: ['Select the plan best suited to you and select the number of units you want to invest in.']
    },
    {
      heading: 'Get Invested ',
      description: ['Simply invest through our sales agent, e-sign required documents.']
    },
    {
      heading: 'Enjoy your earnings',
      description: ['Automate your earnings with assured return at scheduled dates.']
    }
  ]

export const content1 = [
  {
    heading: 'What is Virtual Property?',
    description: ['Virtual Property is a superior solution for having a better efficient passive income over traditional rental income which may or may not come after buying a property.']
  },
  {
    heading: 'Who will you pay to?',
    description: ['You will pay directly to reputed financial institutions like Birla,TATA,HDFC & ICICI etc and receive income from them in your bank account.']
  },
  {
    heading: 'Are the returns guaranteed?',
    description: ['The national level houses like Birla, TATA, HDFC, ICICI are the one who guarantees your income and principal. So you don’t need to worry about a single penny. All the cash flows are fully secured.']
  },
  // {
  //   heading: 'How is my earning Tax Free?',
  //   description: ['There are no tax deduction on the returns received by you as it is the share of profit given by the Farm project entity, which is an LLP, as per section 10(2A). The earnings of the LLP is agriculture income, and is exempted under Section 10(1) of the Income Tax Act,1961 in India.']
  // }
]
